import { render, staticRenderFns } from "./messageIcon.vue?vue&type=template&id=e1e0d672&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1e0d672')) {
      api.createRecord('e1e0d672', component.options)
    } else {
      api.rerender('e1e0d672', component.options)
    }
    module.hot.accept("./messageIcon.vue?vue&type=template&id=e1e0d672&functional=true&", function () {
      api.rerender('e1e0d672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/listView/table/icons/messageIcon.vue"
export default component.exports